import { memo } from 'react';
import { Grid } from 'components/ui';
import { IndexListItemHeader } from 'components/styles_components/list';
import SortableHeader from 'components/sortable_header';
import useMobile from 'hooks/use_mobile';

const ListHeader = ({ visible, sortBy, onSortChange }) => {
  const isMobile = useMobile();

  if (!visible || isMobile) {
    return null;
  }

  return (
    <IndexListItemHeader>
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid size={{ xs: 6 }} textAlign="left">
          <SortableHeader
            field="name"
            label="name"
            sortBy={sortBy}
            onSortChange={onSortChange}
            textAlign="left"
          />
        </Grid>
        <Grid size={{ xs: 3 }} textAlign="center">
          <SortableHeader
            field="incoming_inspections_count"
            label="inspection.incoming.count"
            sortBy={sortBy}
            onSortChange={onSortChange}
          />
        </Grid>
        <Grid size={{ xs: 3 }} textAlign="center">
          <SortableHeader
            field="overdue_inspections_count"
            label="inspection.overdue.count"
            sortBy={sortBy}
            onSortChange={onSortChange}
          />
        </Grid>
      </Grid>
    </IndexListItemHeader>
  );
};

export default memo(ListHeader);
